import React from 'react';
import styled from 'styled-components';

interface Props {
    scrollHeader?: React.ReactNode;
    stickyHeader?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

const TeudaCreateScrollArea: React.FC<Props> = ({
    scrollHeader,
    stickyHeader,
    children,
    className,
}) => (
    <Wrapper className={className}>
        {scrollHeader ? <ScrollHeaderBlock>{scrollHeader}</ScrollHeaderBlock> : null}
        {stickyHeader ? <StickyHeaderSlot>{stickyHeader}</StickyHeaderSlot> : null}
        <List>{children}</List>
    </Wrapper>
);

export default TeudaCreateScrollArea;

const Wrapper = styled.div`
    position: relative;
    flex: 1;
    min-height: 0;
    width: 100%;
    border-radius: ${({ theme }) => theme.radii.lg};
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    padding: 0.25rem 0.75rem calc(70px + env(safe-area-inset-bottom, 0px));
    direction: rtl;
    background: ${({ theme }) => theme.colors.bg};

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0.25rem 0.5rem calc(70px + env(safe-area-inset-bottom, 0px));
    }
`;

const ScrollHeaderBlock = styled.div`
    width: 100%;
    flex-shrink: 0;
`;

const StickyHeaderSlot = styled.div`
    position: sticky;
    top: 0;
    z-index: 10;
    flex-shrink: 0;
    margin: 0 0.25rem;
    padding: 0.5rem 0.625rem;
    border-radius: 1rem;
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.6) 0%,
        rgba(255, 255, 255, 0.32) 40%,
        rgba(255, 255, 255, 0.22) 70%,
        rgba(255, 255, 255, 0.34) 100%
    );
    border: 1px solid rgba(255, 255, 255, 0.45);
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.6),
        inset 0 -0.5px 0 rgba(255, 255, 255, 0.06),
        0 6px 18px -10px rgba(0, 0, 0, 0.16),
        0 18px 32px -22px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(28px) saturate(180%);
    -webkit-backdrop-filter: blur(28px) saturate(180%);
`;

const List = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 0.625rem;
`;
